<template>
  <div>
    <div class="section-head">签到规则配置</div>
    <div class="rule-block">
      <el-row :gutter="24">
        <el-col :span="10">
          <el-form-item label="签到方式" prop="signInRule.method">
            <el-select v-model="signInRule.method" :disabled="true" style="width: 220px">
              <el-option v-for="opt in methodOptions" :key="opt.value" :label="opt.label" :value="opt.value" />
            </el-select>
          </el-form-item>
        </el-col>
        <el-col :span="12">
          <el-form-item label="活动天数" prop="signInRule.cycle_days">
            <el-input-number v-model="signInRule.cycle_days" :min="1" :max="7" :precision="0" :controls="false" style="width: 220px" />
            <span class="cycle-days-tip">活动天数最多7天</span>
          </el-form-item>
        </el-col>
      </el-row>
    </div>
  </div>
</template>

<script setup>
/* eslint-disable no-undef */
const SIGN_IN_METHOD_FIXED_DAYS = 1

defineProps({
  signInRule: {
    type: Object,
    required: true,
  },
})
/* eslint-enable no-undef */

const methodOptions = [
  {
    value: SIGN_IN_METHOD_FIXED_DAYS,
    label: '指定天数',
  },
]
</script>

<style lang="scss" scoped>
.section-head {
  font-size: 15px;
  font-weight: 600;
  color: #303133;
  margin: 16px 0 12px;
  padding-left: 10px;
  border-left: 4px solid #409eff;
  line-height: 1.2;
}

.rule-block {
  padding: 12px;
  background-color: #f5f7fa;
}

.cycle-days-tip {
  font-size: 12px;
  color: #999;
  margin-top: 8px;
  margin-left: 8px;
}
</style>
